<script setup lang="ts">
import ErrorMessage from "~/components/ui/ErrorMessage.vue";
import { genderOptions } from "~/utils/values";

defineProps({
    hasError: { type: Boolean, default: false },
    errorMessage: { type: String, default: "" },
});

const modelValue = defineModel<string>();

const updateModel = (value: string) => {
    modelValue.value = value;
};
</script>

<template>
    <div class="flex justify-center gap-8 rounded-xl px-4" :class="{ 'outline outline-red outline-1': hasError }">

        <button
            v-for="{ label, value } in genderOptions"
            :key="value"
            class="gender-choice"
            :data-testid="`genderChoice-${value}`"
            @click="updateModel(value)"
            @keydown="(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); updateModel(value) } }"
            :aria-pressed="value === modelValue"
            type="button">

            <div class="option" :class="[value === modelValue ? 'selected' : 'bg-gray-1']">

                <div>
                    <span class="text-[24px]"><strong>{{ value }}</strong></span>
                </div>

            </div>

            <span class="text-sm font-medium" v-html="label"></span>

        </button>

    </div>

    <div class="text-left">
        <ErrorMessage v-if="hasError" :message="errorMessage" />
    </div>
</template>

<style scoped>
.gender-choice {
    @apply cursor-pointer flex flex-col rounded-lg px-0 py-2 items-center;
}

.gender-choice .option {
    @apply h-16 w-16 mx-auto rounded-full flex items-center justify-center;

    &.selected {
        @apply bg-yellow;
    }
}
</style>
